import moment from "moment";
import React, { KeyboardEvent, useEffect, useState } from "react";
import axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";
import { qsStringify } from "src/utilities/helper";
import { Button, Modal } from "react-bootstrap";
import { Prompt } from "react-router";
import logger from "../../../utilities/logging"
import "../../../pages/css/BillingGroupPricing/BillingGroupPricing.css"
import { Checkbox } from "@fluentui/react";
interface BillingTableEditableCellProps {
    rowData: rowProps
    index: number
    edit: boolean
    utilities?: utilityProps[]
    locators: EventDictionary<locatorProps[]>
    billing?: billingResponsesProps[]
    update: () => void,
    userId: number
    billingGroupID?: number
    idSearch: (utility: string) => utilityProps
}

interface billingResponsesProps {
    BillingID: number
    BillingResponse: string
    EntryDate?: string
}

interface EventDictionary<TValue> {
    [id: string]: TValue
}

interface locatorProps {
    ResponseID: number
    LocatorResponse: string
}

interface utilityProps {
    UtilityID: number
    UtilityName: string
    ContractID: number
    ContractExpirationDate: string
}

interface rowProps {
    UtilityName: string
    BillingResponse: string
    BillingID: number
    LocatorResponse: string
    ResponseID: number
    Price?: number
    PS?: number
    UR?: string
    knt?: number
    Op?: string
    EffectiveDate: string
    ExpirationDate: string
    BillingGroupPriceID: number
    IsAutoRenew: boolean
}

function BillingTableEditableCell(props: BillingTableEditableCellProps) {
    const index = props.index
    const userId = props.userId
    const [data, setData] = useState<rowProps>(props.rowData)
    const [isEditing, setIsEditing] = useState<boolean>(props.edit)
    const utilities = props.utilities
    const [locator, setBillingLocators] = useState<locatorProps[]>(props.locators[data.UtilityName])
    const billing = props.billing ?? [{ BillingResponse: data.BillingResponse, BillingID: data.BillingID }]
    const [deleteCon, setDeleteCon] = useState(false)
    const [cancelCon, setCancelCon] = useState(false)
    const [saveCon, setSaveCon] = useState(false)
    const [price, setPrice] = useState(props.rowData.Price?.toFixed(2))
    const setNewRowData = (edit: string, index: string, id?: number) => {
        let edits = data
        if (index === "UtilityName") {
            edits.UtilityName = edit
        }
        if (index === "BillingResponse") {
            edits.BillingResponse = edit
            let ids = billing.find(x => x.BillingResponse === edit)?.BillingID
            if (ids) edits.BillingID = ids
        }
        if (index === "LocaterResponse") {
            edits.LocatorResponse = edit
            let ids = locator.find(x => x.LocatorResponse === edit)?.ResponseID
            if (ids) edits.ResponseID = ids
        }
        if (index === "Price") {
            let p = Number(edit) * 100
            p = Math.floor(p) / 100
            edits.Price = p
            const validated = edit.match(/^(-?\d*\.{0,1}\d{0,2}$)/)
            if (validated) {
                setPrice(edit)
            }
        }
        if (index === "PS") {
            edits.PS = Number(edit)
        }
        if(index === "IsAutoRenew"){
            edits.IsAutoRenew = !edits.IsAutoRenew
        }
        if (index === "UR") {
            edits.UR = edit
        }
        if (index === "knt") {
            edits.knt = Number(edit)
        }
        if (index === "Op") {
            edits.Op = edit
        }
        if (index === "EffectiveDate") {
            edits.EffectiveDate = isNaN(moment(edit).valueOf()) ? "" : new Date(edit).toISOString()
        }
        if (index === "ExpirationDate") {
            edits.ExpirationDate = isNaN(moment(edit).valueOf()) ? "" : new Date(edit).toISOString()
        }
        setData({ ...edits })
    }

    const deleteRow = (id: number) => {
        axios.get(process.env.REACT_APP_API_URL + `/api/billing/DeleteBillingGroupPricing/${id}/${Date.now()}/${props.userId}`, AxiosConfig.configValue("min"))
            .finally(() => {
                props.update()
                setIsEditing(false)
            })
            .catch(error => {
                alert("There was an error Deleting Billing Group Pricing");
                //console.log(error);
                logger.Error({
                    EventMessage: `BillingGroupPricing -> DeleteBillingGroupPricing -> Error : ${JSON.stringify(error)}`,
                    EventCategory: "httprequest"
                });
                AxiosConfig.handleError(error);
            })
    }

    // const getUtilityId =async (name:string) => {
    //     let id:number = -99
    //     await axios.get(process.env.REACT_APP_API_URL + `/api/utility/GetIDByName/${name}`, AxiosConfig.configValue())
    //     .then((res) => typeof res.data === "number"? id = res.data: null)
    //     return id

    // }

    const updateRow = async (id: number) => {
        let utility = props.idSearch(data.UtilityName)
        if (Object.values(data).every((x) => x !== null && x !== undefined && x !== "")) {
            if(utility.UtilityID !== -99){
                axios.post(process.env.REACT_APP_API_URL + `/api/billing/UpdateBillingGroupPricing`, qsStringify({
                    BillingGroupPriceID: id,
                    BillingGroupID: props.billingGroupID,
                    UtilityCount: data.knt,
                    Operator: data.Op,
                    UtilityID: utility.UtilityID,
                    ResponseID: data.ResponseID,
                    BillingID: data.BillingID,
                    Price: data.Price,
                    SubPriceSchedule: data.UR,
                    PriceScheduleID: data.PS,
                    EffectiveDate: new Date(data.EffectiveDate).toUTCString(),
                    ExpirationDate: new Date(data.ExpirationDate).toUTCString(),
                    IsAutoRenew: data.IsAutoRenew,
                    ModifyDate: new Date().toUTCString(),
                    ModifiedBy: userId,
                    ContractID: utility.ContractID
                }), AxiosConfig.configValue())
                .then((res) => {
                    if(res.data.error.success === false){
                        throw new Error(res.data.error.message)
                    }
                })
                .finally(() => {
                    props.update()
                    setIsEditing(false)
                })
                .catch(error => {
                    alert("There was an error updating Billing Group Pricing");
                    //console.log(error);
                    logger.Error({
                        EventMessage: `BillingGroupPricing -> UpdateBillingGroupPricing -> Error : ${JSON.stringify(error)}`,
                        EventCategory: "httprequest"
                    });
                    AxiosConfig.handleError(error);
                })
            }
            else{
                alert("Cannot find UtilityID please refresh page and try again")
            }
        }
        else {
            alert("Undefined input detected, fill out form before saving")
        }
    }

    useEffect(() => {
        setData({ ...props.rowData })
        setIsEditing(props.edit)
        setBillingLocators(props.locators[props.rowData.UtilityName])
        setPrice(props.rowData.Price?.toFixed(2))
        //r-18-lint-cn
        //eslint-disable-next-line
    }, [props.rowData, props.locators])

    return (
        <>
            {
                isEditing?
                <tr key={index} className="editableTable">
                    <td className="editableResize">
                        <select onChange={(e) => setNewRowData(e.target.value, "UtilityName")} defaultValue={data.UtilityName} style={{width:`${(6*data.UtilityName.length) + 20}px`}}>
                            {utilities?.map((x:utilityProps, index:number) =>(
                                <option key={index} value={x.UtilityName}>{x.UtilityName}</option>
                            ))}
                        </select>
                    </td>
                    <td className="editableResize">
                        <select 
                            style={{width:`${(6*data.BillingResponse.length) + 20}px`}} 
                            onChange={(e) => setNewRowData(e.target.value, "BillingResponse")} 
                            value={data.BillingResponse}
                        >
                            {billing.map((x:billingResponsesProps, index:number) => (
                                <option key={index} value={x.BillingResponse}>{x.BillingResponse}</option>
                            ))}
                        </select>
                    </td>
                    <td>{data.BillingID}</td>
                    <td className="editableResize">
                        <select 
                            onChange={(e) => setNewRowData(e.target.value, "LocaterResponse")} 
                            value = {data.LocatorResponse} 
                            style={{width:`${(6*data.LocatorResponse.length) +20}px`}}
                        >
                                {locator?.map((x:locatorProps, index:number) => (
                                    <option key={index} value={x.LocatorResponse}>{x.LocatorResponse}</option>
                                ))}
                            </select>
                        </td>
                        <td>{data.ResponseID}</td>
                        <td>
                            <div style={{position: "relative", top:4}}>
                                <Checkbox checked = {data.IsAutoRenew} onChange={() => setNewRowData("", "IsAutoRenew")}/>
                            </div>
                        </td>
                        <td className="editablesMid">
                            <div style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
                                $<input
                                    id="billingPrice"
                                    value={price}
                                    type="number"
                                    onChange={
                                        (e) => {
                                            setNewRowData(e.target.value, "Price")
                                        }
                                    }
                                    onFocus={(e) => e.target.select()}
                                    step="0.01"
                                    onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault()}
                                />
                            </div>
                        </td>
                        <td className="editablesSmall">
                            <input
                                type="number"
                                value={data.PS}
                                size={1}
                                onChange={(e) => setNewRowData(e.target.value, "PS")} onFocus={(e) => e.target.select()}
                                onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault()}
                            />
                        </td>
                        <td className="editablesSmall"><input type="text" value={data.UR} maxLength={1} size={1} onChange={(e) => setNewRowData(e.target.value, "UR")} /></td>
                        <td className="editablesSmall">
                            <input
                                type="number"
                                defaultValue={data.knt}
                                size={1}
                                onChange={(e) => setNewRowData(e.target.value, "knt")} onFocus={(e) => e.target.select()}
                                onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+'].includes(event.key) && event.preventDefault()}
                            />
                        </td>
                        <td className="editablesSmall"><input type="text" value={data.Op} maxLength={1} size={1} onChange={(e) => setNewRowData(e.target.value, "Op")} /></td>
                        <td className="tableDates">
                            <input
                                type='date'
                                onChange={(e) => { setNewRowData(moment(e.target.value).format('MM/DD/YYYY'), "EffectiveDate") }}
                                defaultValue={moment(data.EffectiveDate).format("YYYY-MM-DD")}
                            />
                        </td>
                        <td className="tableDates">
                            <input
                                type='date'
                                onChange={(e) => { setNewRowData(moment(e.target.value).format('MM/DD/YYYY'), "ExpirationDate") }}
                                defaultValue={moment(data.ExpirationDate).format("YYYY-MM-DD")}
                            />
                        </td>
                        <td>
                            <div className="BGtableIcons">
                                <span className="material-icons"
                                    onClick={() => {
                                        setCancelCon(true)
                                    }}
                                >
                                    clear
                                </span>
                                <span className="material-icons" onClick={() => setSaveCon(true)}>
                                    save
                                </span>
                            </div>
                        </td>
                    </tr> :
                    <tr key={index} onClick={() => setIsEditing(true)} className="nonEditTable">
                        <td className="editableResize">{props.rowData.UtilityName}</td>
                        <td className="editableResize">{props.rowData.BillingResponse}</td>
                        <td>{props.rowData.BillingID}</td>
                        <td className="editableResize">{props.rowData.LocatorResponse}</td>
                        <td>{props.rowData.ResponseID}</td>
                        <td>
                            <div style={{position: "relative", top:4}}>
                                <Checkbox checked = {props.rowData.IsAutoRenew} onChange={() => null}/>
                            </div>
                        </td>
                        <td>${props.rowData.Price?.toFixed(2) ?? 0.00}</td>
                        <td>{props.rowData.PS}</td>
                        <td>{props.rowData.UR}</td>
                        <td>{props.rowData.knt}</td>
                        <td>{props.rowData.Op}</td>
                        <td>{props.rowData.EffectiveDate.split('T')[0]}</td>
                        <td>{props.rowData.ExpirationDate.split('T')[0]}</td>
                        <td style={{ width: "100px" }}><span className="material-icons" onClick={() => setDeleteCon(true)}>delete</span></td>
                    </tr>
            }
            <Modal show={deleteCon} size="lg" onHide={() => setDeleteCon(false)}>
                <Modal.Header>
                    <span>Are you sure you want to delete this record </span>
                </Modal.Header>
                <Modal.Footer>
                    {/*r-18-lint-cn*/}
                    {/*eslint-disable-next-line*/}
                    <Button onClick={() => (deleteRow(props.rowData.BillingGroupPriceID), setDeleteCon(false))} variant='primary'>Yes</Button>
                    {/*r-18-lint-cn*/}
                    {/*eslint-disable-next-line*/}
                    <Button onClick={() => (setDeleteCon(false), setIsEditing(false))} variant='secondary'>No</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={saveCon} size="lg" onHide={() => setSaveCon(false)}>
                <Modal.Header>
                    <span>Are you sure you want to edit this record </span>
                </Modal.Header>
                <Modal.Footer>
                    {/*r-18-lint-cn*/}
                    {/*eslint-disable-next-line*/}
                    <Button onClick={() => (updateRow(data.BillingGroupPriceID), setSaveCon(false))} variant='primary'>Yes</Button>
                    <Button onClick={() => (setSaveCon(false))} variant='secondary'>No</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={cancelCon} size="lg" onHide={() => setDeleteCon(false)}>
                <Modal.Header>
                    <span>Are you sure you want to cancel editing record </span>
                </Modal.Header>
                <Modal.Footer>
                    {/*r-18-lint-cn*/}
                    {/*eslint-disable-next-line*/}
                    <Button onClick={() => (setIsEditing(false),
                        setData({ ...props.rowData }),
                        setCancelCon(false))}
                        variant='primary'>
                        Yes
                    </Button>
                    <Button onClick={() => (setCancelCon(false))} variant='secondary'>No</Button>
                </Modal.Footer>
            </Modal>
            <Prompt
                when={isEditing}
                message='You have unsaved changes, are you sure you want to leave?'
            />
        </>
    )
}

export default BillingTableEditableCell